<template>
  <!--  CONTENEDOR PRINCIPAL (tipo modal simple) -->
  <div v-if="visible" class="overlay-servicio">
    <div class="pos-servicios">
      <!-- BOTÓN CERRAR -->
      <button class="btn-cerrar" @click="cerrar">✖</button>

      <!-- IZQUIERDA: SERVICIOS -->
      <div class="panel-servicios">
        <h2>Servicios</h2>

        <div v-if="servicios.length === 0">
          No hay servicios cargados
        </div>

        <input v-model.trim="busqueda" placeholder="Buscar servicio..." class="input-busqueda" />

        <div class="grid-servicios">
          <button v-for="srv in serviciosFiltrados" :key="srv.idServicio" @click="seleccionarServicio(srv)" :class="{
            activo:
              servicioSeleccionado &&
              servicioSeleccionado.idServicio === srv.idServicio,
          }">
            <img v-if="srv.logoSrc" :src="srv.logoSrc || 'https://via.placeholder.com/40'" class="img-servicio" />

            <span>{{ srv.servicio }}</span>
          </button>
        </div>
      </div>

      <!-- DERECHA: DETALLE -->
      <div class="panel-detalle">
        <h2>Pago</h2>
        <div v-if="servicioSeleccionado">
          <h3>{{ servicioSeleccionado.servicio }}</h3>

          <div class="grid-productos">
            <button v-for="prod in productos" :key="prod.idProducto" @click="seleccionarProducto(prod)" :class="{
              activo:
                productoSeleccionado &&
                productoSeleccionado.idProducto === prod.idProducto,
            }">
              <img v-if="prod.logoSrc" :src="prod.logoSrc || 'https://via.placeholder.com/40'" class="img-producto" />

              <span>{{ prod.producto }}</span>
              <small>${{ prod.precio }}</small>
            </button>
          </div>
        </div>
        <div v-if="this.verPago">
          <div class="campo">
            <label>Referencia</label>
            <input v-model="referencia" @keyup.enter="consultarServicio" />
          </div>

          <div v-if="this.verConsulta">
            <button class="btn-consultar" @click="consultarServicio">
              Consultar
            </button>
          </div>

          <div v-if="cliente">
            <p><b>Cliente:</b> {{ cliente }}</p>
            <p><b>Adeudo:</b> ${{ adeudo }}</p>
          </div>

          <div class="pagos">
            <button @click="metodoPago = 'efectivo'" :class="{ activo: metodoPago === 'efectivo' }">
              Efectivo
            </button>

            <button @click="metodoPago = 'tarjeta'" :class="{ activo: metodoPago === 'tarjeta' }">
              Tarjeta
            </button>
          </div>

          <div v-if="metodoPago === 'efectivo'" class="campo">
            <label>Recibido</label>
            <input v-model.number="recibido" />
          </div>

          <p v-if="metodoPago === 'efectivo'"><b>Cambio:</b> ${{ cambio }}</p>

          <button
  class="btn-pagar"
  @click="pagar"
  :disabled="!puedePagar"
>
  PAGAR
</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import dataServicios from "@/assets/servicios.json";
import { consultarServicios, PagoServicioSinReferencia,SaveLogWS } from "@/services/terpayApi.js";
import {POSEnc,POSEncFunctions} from "../controllers/POSController.js";
import * as Cookies from 'js-cookie'; //Importa cookies
import { POSDet } from "@/controllers/POSController"; 
export default {
  name: "ServiciosComponent",

  props: {
    value: Boolean,
  },

  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    puedePagar() {
  if (!this.productoSeleccionado) return false;

  // En tarjeta no se valida recibido
  if (this.metodoPago === "tarjeta") {
    return true;
  }

  // En efectivo debe cubrir el total
  if (this.metodoPago === "efectivo") {
    return Number(this.recibido) >= Number(this.productoSeleccionado.precio);
  }

  return false;
},
    serviciosFiltrados() {
      const texto = this.busqueda.toLowerCase();

      return this.servicios.filter((srv) =>
        srv.servicio
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(texto.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
      );
    },

    cambio() {
      const total = this.productoSeleccionado
    ? Number(this.productoSeleccionado.precio)
    : Number(this.adeudo);

  return Number(this.recibido) - total;
    },
  },

  data() {
    return {
      servicios: [],
      productoSeleccionado: null,
      servicioSeleccionado: null,
      productos: [],
      verConsulta: false,
      verPago: false,
      referencia: "",
      busqueda: "",
      cliente: "",
      adeudo: 0,
      POSEncFunctions: new POSEncFunctions(),
      metodoPago: null,
      POSEnc: new POSEnc(),
      recibido: 0,
    };
  },

  mounted() {
    this.cargarServicios();
  },

  methods: {
    cerrar() {
      this.visible = false;
      this.referencia = "";
      this.cliente = "";
      this.adeudo = 0;
      this.recibido = 0;
      this.metodoPago = null;
      this.productoSeleccionado = null;
      this.verPago = false;
      this.verConsulta = false;
      this.servicioSeleccionado = false;
      this.$nextTick(() => {
        this.$emit("nuevo-pos-enc");
      });
    },
    validarTelefono() {
      return /^[0-9]{10}$/.test(this.referencia);
    },

    seleccionarServicio(srv) {
      this.servicioSeleccionado = srv;
      this.productos = srv.productoDTOList;
      this.productoSeleccionado = null;
      this.verPago = false;
      this.verConsulta = false;
    },
    // cargarServicios() {
    //   this.servicios = dataServicios
    //     .filter(x => x.serviciosDTOS)
    //     .flatMap(x => x.serviciosDTOS);
    // },
    async obtenerUbicacion() {
      return new Promise((resolve, reject) => {

        if (!navigator.geolocation) {
          reject("El navegador no soporta geolocalización");
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude.toString(),
              longitude: position.coords.longitude.toString()
            });
          },
          (error) => reject(error)
        );
      });
    },
    async obtenerIp() {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    },
    async obtenerDatosCliente() {

      const ubicacion = await this.obtenerUbicacion();


      return {
        ip_address: "",
        latitude: ubicacion.latitude,
        longitude: ubicacion.longitude
      };
    },

    async cargarServicios() {
      try {
        const data = await consultarServicios();

        console.log("DATA REAL:", data);

        this.servicios = data.flatMap((x) => x.serviciosDTOS);
      } catch (error) {
        console.error("Error cargando servicios:", error);
        this.servicios = [];
      }
    },

    consultarServicio() {
      if (!this.referencia) {
        throw alert("Capture Referencia");
      }
      this.cliente = "Juan Pérez";
      this.adeudo = 1250;
    },

    seleccionarProducto(prod) {
      this.productoSeleccionado = prod;
      console.log(this.productoSeleccionado);
      this.verPago = true;
      if (this.productoSeleccionado.tipoFront == 2) {
        this.verConsulta = true;
      }
    },

    // pagar() {


    //   if (!this.productoSeleccionado) {
    //     alert("Selecciona un producto");
    //     return;
    //   }
    //   if (!this.servicioSeleccionado) {
    //     alert("Selecciona un servicio");
    //     return;
    //   }

    //   if (!this.referencia) {
    //     alert("Captura referencia");
    //     return;
    //   }


    //   alert("Pago realizado correctamente");

    //   // reset
    //   this.referencia = "";
    //   this.cliente = "";
    //   this.adeudo = 0;
    //   this.recibido = 0;
    //   this.metodoPago = null;
    //   this.productoSeleccionado = null;
    //   this.verPago = false;
    //   this.verConsulta = false;
    //   this.servicioSeleccionado = null;

    //   this.cerrar();
    // },
    async pagar() {

      if (!this.productoSeleccionado) {
        alert("Selecciona un producto");
        return;
      }

      if (!this.servicioSeleccionado) {
        alert("Selecciona un servicio");
        return;
      }

      if (!this.referencia) {
        alert("Captura referencia");
        return;
      }
      if (this.metodoPago === "efectivo") {
  const total = Number(this.productoSeleccionado.precio);

  if (Number(this.recibido) < total) {
    alert("El efectivo recibido es menor al monto del pago.");
    return;
  }
}
      console.log(this.servicioSeleccionado);
      console.log(this.productoSeleccionado);
      this.POSEnc.intPOSRegister = Cookies.get("POS_REGISTER_CAJA");
      this.POSEnc.intPOSTipoServicio = 4;
      this.POSEnc.dblSubtotal = this.productoSeleccionado.precio;
      this.POSEnc.dblTotal = this.productoSeleccionado.precio;
      this.POSEnc.strMaquinaAlta = Cookies.get("POS_USER");
      console.log(this.POSEnc);
      // Servicio 1 + TipoFront 1 = Recarga telefónica
      if (this.productoSeleccionado.idCatTipoServicio === 1 && this.productoSeleccionado.tipoFront === 1) 
      {

        if (!this.validarTelefono()) {
          alert("Capture un número telefónico de 10 dígitos.");
          return;
        }

        try {
          const datosCliente = await this.obtenerDatosCliente();
          const model = {
            empresa: "TERPAY",
            monto: this.productoSeleccionado.precio,
            telefono: this.referencia,
            cuentaOrdenante: "646180525200000012",
            catalogo: this.productoSeleccionado.idCatTipoServicio,
            servicio: this.productoSeleccionado.idServicio,
            idProducto: this.productoSeleccionado.idProducto,
            user: Cookies.get("POS_USER"),
            ip_address: datosCliente.ip_address,
            latitude: datosCliente.latitude,
            longitude: datosCliente.longitude
          };
          console.log(model);
          const respuesta = await PagoServicioSinReferencia(model);
          console.log(respuesta);
          const detalle = new POSDet();

detalle.strNombreCorto = "SER";
detalle.strNombre = respuesta.servicio;
detalle.dblPU = this.productoSeleccionado.precio;
detalle.dblTotal = this.productoSeleccionado.precio;
detalle.dblCantidad = 1;
detalle.intEstatus = 2;

this.POSEnc.posDet.push(detalle);
          
          // if (respuesta.estado !== 0) {
          //   //Se guarda solamente el log de error
          //   await SaveLogWS({urlWS: "PagoServicioSinReferencia", tipoDocumento: 24, documento1: 0, documento2: 0, request: JSON.stringify(model), result: JSON.stringify(respuesta)});
          //   alert(respuesta.mensaje);
          //   return;
          // }
          // else
          // {
            //Se crea venta 
            const posEncPOST = await this.POSEncFunctions.saveServicio(this.POSEnc);
            await SaveLogWS({urlWS: "PagoServicioSinReferencia", tipoDocumento: 24, documento1: posEncPOST.intPOSEnc, documento2: 0, request: JSON.stringify(model), result: JSON.stringify(respuesta)});
          //}



          alert(
            `Recarga realizada correctamente Autorización: ${respuesta.numAutorizacion} Teléfono: ${respuesta.referencia} Monto: $${respuesta.monto}`
          );

          console.log("Leyenda:", respuesta.leyenda);
          console.log("Clave:", respuesta.claveRastreo);

          this.cerrar();

        } catch (error) {
          alert("Ocurrió un error al realizar la recarga.");
          console.error(error);
          console.log(error.response);
  console.log(error.response.data);
  console.log(error.response.status);
        }

        return;
      }
      else {
        console.log("ELSE DE PAGAR");
        console.log(this.productoSeleccionado);
      }

      //   alert("Pago realizado correctamente");

      //   // reset
      //   this.referencia = "";
      //   this.cliente = "";
      //   this.adeudo = 0;
      //   this.recibido = 0;
      //   this.metodoPago = null;
      //   this.productoSeleccionado = null;
      //   this.verPago = false;
      //   this.verConsulta = false;
      //   this.servicioSeleccionado = null;
    }
  },
};
</script>

<style>
/* overlay  */
.overlay-servicio {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}

.pos-servicios {
  display: flex;
  height: 100vh;
  font-family: Arial;
  background: white;
}

/* botón cerrar */
.btn-cerrar {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  background: red;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
}

/* panel servicios */
.panel-servicios {
  width: 40%;
  background: #1e1e2f;
  color: white;
  padding: 20px;
  overflow-y: auto;
}

.grid-servicios {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  overflow-y: auto;
  flex: 1;
}

.grid-servicios button {
  padding: 20px;
  font-size: 18px;
  border: none;
  background: #2e2e40;
  color: white;
  cursor: pointer;
}

.grid-servicios button.activo {
  background: #00c853;
}

/* panel detalle */
.panel-detalle {
  width: 60%;
  padding: 20px;
  background: #f5f5f5;
  height: 100vh;
  overflow-y: auto;
  /* display: flex;
  flex-direction: column; */
}

.campo {
  margin-bottom: 10px;
}

input {
  width: 100%;
  padding: 10px;
  font-size: 18px;
}

.pagos button {
  margin-right: 10px;
  padding: 10px 20px;
}

.btn-pagar {
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  font-size: 20px;
  background: #00c853;
  color: white;
  border: none;
}

.grid-productos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 15px;
  overflow-y: visible;
  max-height: none;
}

.grid-productos button {
  padding: 15px;
  font-size: 16px;
  border: none;
  background: #ddd;
  cursor: pointer;
}

.grid-productos button.activo {
  background: #00c853;
  color: white;
}

.input-busqueda {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  font-size: 25px;
  border: none;
  border-radius: 5px;
  outline: none;
  color: #fff !important;
  background: #2e2e40 !important;
  -webkit-text-fill-color: #fff;
}

.input-busqueda::placeholder {
  color: #ccc;
}

.input-busqueda:focus {
  color: #fff !important;
  -webkit-text-fill-color: #fff;
}

.grid-servicios button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.btn-pagar:disabled {
  background: #999;
  cursor: not-allowed;
  opacity: .6;
}
.img-servicio {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-bottom: 5px;
}

.grid-productos button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.img-producto {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-bottom: 5px;
}
</style>
